import { generateUniqueId } from '@/helpers/uuidUtils';
import { AccessoryService } from '@/models/installationPoint/AccessoryService';
import { DeviceService } from '@/models/installationPoint/DeviceService';
import { Type } from 'class-transformer';
import 'reflect-metadata';
import { DeviceServiceReasonEnum, DeviceServiceTypeEnum } from '@/enums/device';

export class TKDService {
  id: string;
  ticketNumber: string;
  errorDescription: string;
  report: string;
  @Type(() => DeviceService)
  deviceService?: DeviceService;
  @Type(() => AccessoryService)
  accessoryServices: AccessoryService[];
  timestamp: string;
  hasUnknownDevice: boolean;
  // "Fremdverschulden" — installer flags a resident-caused fault so the
  // dispatcher can invoice correctly. Aligns to the BE contract field name.
  thirdPartyFault: boolean;

  constructor() {
    this.id = generateUniqueId();
    this.ticketNumber = '';
    this.errorDescription = '';
    this.report = '';
    this.deviceService = new DeviceService();
    this.accessoryServices = [];
    this.timestamp = new Date().toISOString();
    this.hasUnknownDevice = false;
    this.thirdPartyFault = false;
  }

  setNoTKDPossible(isTKDPossible: boolean) {
    if (!this.deviceService) return;

    if (!isTKDPossible) {
      this.deviceService.type = DeviceServiceTypeEnum.NO_SERVICE_POSSIBLE;
      this.deviceService.reason = this.deviceService.reason ?? undefined;
      this.deviceService.note = this.deviceService.note ?? undefined;
      return;
    }

    this.deviceService.type = DeviceServiceTypeEnum.EXCHANGE;
    this.deviceService.reason = DeviceServiceReasonEnum.OLD_VERSION;
    this.deviceService.note = undefined;
  }
}
